import { Injectable } from '@angular/core';
import { UserPreferencesService } from 'app/shared/services-api-central/user-preferences/user-preferences.service';
import { BehaviorSubject, Observable } from 'rxjs';


/**
 * @deprecated
 * This service is deprecated and will be removed in future versions. Please use UserPreferencesService instead.
 */

@Injectable({
  providedIn: 'root'
})
export class UnitsService {
  private detectUnitChange$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private userPreferencesService: UserPreferencesService,
  ) {}

  public getDetectUnitChanges(): Observable<boolean> {
    return this.detectUnitChange$.asObservable();
  }

  public getThousandSeparator(): string {
    return this.userPreferencesService.thousandSeparator;
  }

  public setThousandSeparator(separator: string): void {
    this.userPreferencesService.thousandSeparator = separator;
    this.detectUnitChange$.next(true);
  }

  public getDecimalSeparator(): string {
    return this.userPreferencesService.decimalSeparator;
  }

  public setDecimalSeparator(separator: string): void {
    this.userPreferencesService.decimalSeparator = separator;
    this.detectUnitChange$.next(true);
  }
}
